import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

export const BorderedBox = styled(Box)(({ theme }) => ({
  padding: 12,
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${grey[300]}`,
  borderRadius: 24,
}));

export const BorderedStack = styled(Stack)(
  ({ theme, bgcolor, paddingY, paddingX }) => ({
    paddingX: paddingX || 12,
    paddingY: paddingY || 12,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${grey[300]}`,
    backgroundColor: bgcolor || "transparent",
    borderRadius: 24,
  })
);
